import { useState } from "react";
import { MessageCircleQuestion, Plus, StickyNote } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { useFetch } from "@/hooks/useFetch";
import { spaceParams } from "@/lib/spaces";
import { Empty, Loading, PageHeader, PrimaryButton, Segmented } from "@/components/Bits";
import { NoteCard } from "@/components/NoteCard";

const THOUGHT_FILTERS = [
  { value: "open", label: "To discuss" },
  { value: "discussed", label: "Discussed" },
  { value: "all", label: "All" },
];

export default function Notes({ kind }) {
  const { space, openAdd } = useApp();
  const [filter, setFilter] = useState("open");
  const thought = kind === "thought";
  const params = { ...spaceParams(space), kind };
  if (thought && filter !== "all") params.discussed = filter === "discussed";
  const items = useFetch("/notes", params);

  return (
    <div data-testid={`${kind}s-page`}>
      <PageHeader
        title={thought ? "To discuss" : "Notes"}
        subtitle={thought ? "Thoughts and ideas to bring up with the team. Tick them off once talked through." : "Plain notes. No emails, no reminders."}>
        {thought && <Segmented options={THOUGHT_FILTERS} value={filter} onChange={setFilter} testid="thoughts-filter" />}
        <PrimaryButton onClick={() => openAdd(kind)} data-testid={thought ? "add-thought-btn" : "add-note-btn"}>
          <Plus className="h-4 w-4" /> {thought ? "Log a thought" : "New note"}
        </PrimaryButton>
      </PageHeader>
      {!items ? <Loading /> : items.length === 0 ? (
        <Empty icon={thought ? MessageCircleQuestion : StickyNote} text={thought ? "Nothing here yet." : "No notes yet."} testid={`empty-${kind}s`} />
      ) : (
        <div className="columns-1 gap-4 md:columns-2 xl:columns-3">{items.map((n) => <NoteCard key={n.id} n={n} />)}</div>
      )}
    </div>
  );
}
